import {PUBLIC_BASE_PATH} from "./env";

const RETURN_TO = "esfinge.return-to";
const rootPath = () => `${PUBLIC_BASE_PATH || ""}/`;
const unsafeCharacters = (value) =>
    [...value].some(
        (character) => character === "\\" || character.charCodeAt(0) <= 32
    );
export const appRoot = () => new URL(rootPath(), window.location.origin).href;

export function safeDestination(value) {
    const fallback = rootPath();
    if (
        typeof value !== "string" ||
        !value.startsWith("/") ||
        value.startsWith("//") ||
        unsafeCharacters(value)
    )
        return fallback;
    try {
        const url = new URL(value, window.location.origin);
        const decodedPath = decodeURIComponent(url.pathname);
        if (
            url.origin !== window.location.origin ||
            unsafeCharacters(decodedPath) ||
            decodedPath.startsWith("//") ||
            /%2f|%5c|%2e/i.test(decodedPath)
        )
            return fallback;
        const base = PUBLIC_BASE_PATH || "";
        if (
            base &&
            url.pathname !== base &&
            !url.pathname.startsWith(`${base}/`)
        )
            return fallback;
        if (
            decodedPath.split("/").some((part) => part === ".." || part === ".")
        )
            return fallback;
        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return fallback;
    }
}
export const currentDestination = () =>
    safeDestination(
        `${window.location.pathname}${window.location.search}${window.location.hash}`
    );
export function rememberDestination(value) {
    try {
        sessionStorage.setItem(RETURN_TO, safeDestination(value));
    } catch {
        /* Navegação continua mesmo com armazenamento indisponível. */
    }
}
export function rememberedDestination() {
    try {
        return safeDestination(sessionStorage.getItem(RETURN_TO));
    } catch {
        return rootPath();
    }
}
export function restoreDestination() {
    try {
        const saved = sessionStorage.getItem(RETURN_TO);
        sessionStorage.removeItem(RETURN_TO);
        if (saved) {
            window.history.replaceState(null, "", safeDestination(saved));
            // O roteador já está montado enquanto a guarda verifica a sessão.
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    } catch {
        /* O navegador pode impedir sessionStorage. */
    }
}
